// Este archivo contiene la configuración de Firebase
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

// Configuración de Firebase
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyDrZbT_aOwgk0bmIVXVcpf3RQiwENfrufU',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'nfc-sos-9de6f.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'nfc-sos-9de6f',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'nfc-sos-9de6f.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '831156086081',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:831156086081:web:4aea94e6cd6e47a3286dc0',
};

// Inicializar Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Proveedores de autenticación
export const googleProvider = new GoogleAuthProvider();

// Configuración para entorno de desarrollo
if (process.env.NODE_ENV === 'development') {
  // Configuración para usar emuladores locales de Firebase durante el desarrollo
  // Nota: Para usar esto, debes iniciar los emuladores con 'firebase emulators:start'
  // const EMULATOR_HOST = 'localhost';
  // connectAuthEmulator(auth, `http://${EMULATOR_HOST}:9099`);
  // connectFirestoreEmulator(db, EMULATOR_HOST, 8080);
  // connectFunctionsEmulator(functions, EMULATOR_HOST, 5001);
  // connectStorageEmulator(storage, EMULATOR_HOST, 9199);
  
  // Log de configuración para depuración
  console.log('Firebase inicializado en modo desarrollo con configuración:', 
    { 
      ...firebaseConfig,
      apiKey: firebaseConfig.apiKey?.substring(0, 5) + '...[truncado]' // Por seguridad no mostramos la clave completa
    });
  // Descomenta estas líneas cuando uses los emuladores de Firebase
  /* 
  connectAuthEmulator(auth, 'http://localhost:9099');
  connectFirestoreEmulator(db, 'localhost', 8080);
  connectFunctionsEmulator(functions, 'localhost', 5001);
  connectStorageEmulator(storage, 'localhost', 9199);
  */
}
